<template>
  <section class="content-categories-default">
    <Breadcrumb :links="links"/>
    <div class="content-categories-default-body">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="category in plansCategories" :key="category.id">
          <CardCategory :category="category" :isType="'Plans'"/>
        </div>
      </div>
    </div>
    <ModalDelete/>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardCategory from '@/components/cards/CardCategory';
import ModalDelete from '@/components/modals/ModalDelete';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Planos',
          routerName: 'Plans'
        },
        {
          name: 'Categorias',
          routerName: 'ListPlansCategories'
        },
      ],
    }
  },
  components: {
    Breadcrumb,
    CardCategory,
    ModalDelete
  },
  computed: {
    ...mapGetters('Plans', ['plansCategories'])
  },
  methods: {
    ...mapActions('Plans', ['consultCategoriesPlans', 'registerCategoryPlans'])
  },
  mounted() {
    this.consultCategoriesPlans();
  }
}
</script>

<style lang="scss">
</style>
